// extracted by mini-css-extract-plugin
export default {"infoWrap":"info_infoWrap__65g+y","block":"info_block__eTC6R","label":"info_label__hA+kt","value":"info_value__YNlBD"};